import { h } from 'preact';
import React, { Component } from 'react';
import Toggle from '../Components/Toggle';
import { makeText, formatDescription } from '../../../util';

export default class SpecialPurposeContent extends Component {
  state = {
    all: false
  }
  toggleAll = () => {
    const all = !this.state.all;
    this.setState({ all }, this.props.force);
  }
  render() {
    const { purpose, language, settings, force, dev, accordionOpen } = this.props;
    const { all } = this.state;

    const viewAllText = makeText(Boolean(dev), settings, 'viewAllText', language);
    const viewLessText = makeText(Boolean(dev), settings, 'viewLessText', language);
    const vendorTitleText = makeText(Boolean(dev), settings, 'vendorTitleText', language);

    if (settings.alphabetizeVendors) {
      if (purpose.vendors) {
        purpose.vendors.sort((a, b) => {
          if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
          if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
          return 0;
        });
      }
    }

    return (
      <div className="purpose-content ">
        <p style="margin-bottom:15px;">{formatDescription(purpose.description)}</p>
        <div>
        {purpose.vendors.length} {vendorTitleText}
          <div className="policies">
            {purpose.vendors.slice(0, all ? purpose.vendors.length : 3).map((v) => (
              <Toggle
                vendor={v}
                key={v.vendorId}
                language={language}
                settings={settings}
                force={force}
                dev={dev}
                accordionOpen={accordionOpen}
                isSpecialPurpose
              />
            ))}
            {purpose.vendors.length > 3 ? (
              <div
                className="view-all"
                role="button"
                onClick={this.toggleAll}
              >
                {all ? viewLessText : viewAllText}
              </div>
            ) : null}
          </div>
        </div>

      </div>
    );
  }
}